/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "../../clients/audit-reports-api-client";
import type { Client, RequestConfig, ResponseErrorConfig } from "../../clients/audit-reports-api-client";
import type { ListReportDefinitionQueryResponse, ListReportDefinitionQueryParams } from "../models/ListReportDefinition";

export function getListReportDefinitionUrl() {
  const res = { method: 'GET', url: `/report-definitions` as const }
  return res
}

/**
 * @description Returns all report definitions for the client, optionally filtered by report type
 * @summary List all report definitions
 * {@link /report-definitions}
 */
export async function listReportDefinition(params?: ListReportDefinitionQueryParams, config: Partial<RequestConfig> & { client?: Client } = {}) {
  const { client: request = fetch, ...requestConfig } = config



  const res = await request<ListReportDefinitionQueryResponse, ResponseErrorConfig<Error>, unknown>({ method : "GET", url : getListReportDefinitionUrl().url.toString(), params, ... requestConfig })
  return res.data
}